export const facebookImage = require("../assets/facebook-circled.png");
export const googleImage = require("../assets/GoogleLogo.png");
